import { Search } from "@mui/icons-material";
import { SetStateAction } from "react";

type props = {
    searchValue: string;
    setSearchValue: (value: SetStateAction<string>) => void;
    placeholder: string;
}

const InputSearch = ({
    searchValue,
    setSearchValue,
    placeholder,
}: props) => {
    return (
        <div style={{ position: 'relative', flex: 1, maxWidth: 360, margin: '0 16px' }}>
            <Search style={{ position: 'absolute', left: 10, top: 10, color: '#888' }} />
            <input
            type="text"
            placeholder={placeholder}
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            style={{ width: '100%', padding: '10px 10px 10px 40px', borderRadius: 20, border: '1px solid #ddd', outline: 'none' }}
            />
        </div>
    )
}

export default InputSearch;